import { createContext, useContext, useEffect, useState, ReactNode } from 'react'

type ConsentState = {
  analytics: boolean
}

type ConsentContextType = {
  consent: ConsentState
  setAnalyticsConsent: (value: boolean) => void
}

const DEFAULT_CONSENT: ConsentState = { analytics: false }
const CONSENT_STORAGE_KEY = 'mypet_consent_v1'

const ConsentContext = createContext<ConsentContextType | undefined>(undefined)

export function ConsentProvider({ children }: { children: ReactNode }) {
  const [consent, setConsent] = useState<ConsentState>(DEFAULT_CONSENT)

  useEffect(() => {
    try {
      const raw = localStorage.getItem(CONSENT_STORAGE_KEY)
      if (raw) {
        const parsed = JSON.parse(raw) as ConsentState
        setConsent({ analytics: !!parsed.analytics })
      }
    } catch {
      // ignore
    }
  }, [])

  const setAnalyticsConsent = (value: boolean) => {
    const next = { analytics: value }
    setConsent(next)
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(next))
    } catch {
      // ignore
    }
  }

  return (
    <ConsentContext.Provider value={{ consent, setAnalyticsConsent }}>
      {children}
    </ConsentContext.Provider>
  )
}

export function useConsent() {
  const ctx = useContext(ConsentContext)
  if (!ctx) throw new Error('useConsent must be used within ConsentProvider')
  return ctx
}


